export default {
  bind(el) {
    const formatValue = (value) => {
      // Remove non-digit characters
      value = value.replace(/[^\d]/g, '')

      if (value.length === 0) {
        return '0,00'
      }

      const numValue = parseFloat(value) || 0

      // Format number with two decimal places
      let [integerPart, decimalPart] = (numValue / 100).toFixed(2).split('.')

      // Add thousands separators with dots
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      // Combine integer and decimal parts with a comma for decimals
      return `${integerPart},${decimalPart}`
    }

    const handleInput = (e) => {
      const formattedValue = formatValue(e.target.value)
      e.target.value = formattedValue

      // Modify and dispatch a custom event to update the bound v-model
      if (typeof Event === 'function') {
        // Modern browsers
        const event = new Event('input', { bubbles: true })
        Object.defineProperty(event, 'target', { writable: false, value: el })
        el.dispatchEvent(event)
      }
    }

    el.addEventListener('input', handleInput)
    el.addEventListener('blur', handleInput)

    el.addEventListener('focus', (e) => {
      if (e.target.value === '0,00') {
        e.target.value = ''
      }
    })
  }
}
